var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgMostUsed = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 21.8787L8.8934 18.7721H3C2.17157 18.7721 1.5 18.1005 1.5 17.2721V3C1.5 2.17157 2.17157 1.5 3 1.5H21C21.8284 1.5 22.5 2.17157 22.5 3V17.2721C22.5 18.1005 21.8284 18.7721 21 18.7721H15.1066L12 21.8787ZM8.27208 20.2721L12 24L15.7279 20.2721H21C22.6569 20.2721 24 18.9289 24 17.2721V3C24 1.34315 22.6569 0 21 0L3 0C1.34315 0 0 1.34315 0 3L0 17.2721C0 18.9289 1.34315 20.2721 3 20.2721H8.27208Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.8274 7.51442L14.0067 7.85652L14.3894 7.90918L18.4099 8.4625L15.5319 11.1018L15.2268 11.3817L15.301 11.789L15.987 15.5551L12.3328 13.7457L12 13.5809L11.6672 13.7457L8.01299 15.5551L8.69902 11.789L8.77322 11.3817L8.46808 11.1018L5.59005 8.4625L9.61061 7.90918L9.99327 7.85652L10.1726 7.51442L12 4.02874L13.8274 7.51442ZM16.0806 16.0688C16.0806 16.0687 16.0805 16.0686 16.0805 16.0684L16.0806 16.0688Z",
    stroke: "currentColor",
    fill: "none",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgMostUsed);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/most-used.2eb83d1d730a90b9dcb79d92e9fe675b.svg";